module.exports = __webpack_public_path__ + "images/topics/mammals/sensory_detection.png";